<template>
  <el-container v-title data-title="学生考勤统计" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>考勤管理</el-breadcrumb-item>
                <el-breadcrumb-item>学校学生考勤统计</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form ref="searchForm" :inline="true" :model="searchForm" :rules="rules" class="demo-form-inline" >
                <el-form-item label="日期" :required="true" prop="date">
                  <el-date-picker
                    v-model="searchForm.date"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyyMMdd"
                    :picker-options="pickerOptions">
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="getStatsForStudentReader">查询</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column prop="schoolName" label="学校" width="120"></el-table-column>
          <el-table-column prop="totalQty" label="总学生数" width="120"></el-table-column>
          <el-table-column label="已考勤数" width="120">
            <template slot-scope="scope">
              <el-button type="text" @click="getStatsDetailListForStudentReader(scope.row, 'attended')">{{scope.row.attendedQty}}</el-button>
            </template>
          </el-table-column>
          <el-table-column label="未考勤数" width="120">
            <template slot-scope="scope">
              <el-button type="text" @click="getStatsDetailListForStudentReader(scope.row, 'unattended')">{{scope.row.unattendedQty}}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="rate" label="考勤率" width="120"></el-table-column>
        </el-table>
      </el-main>
      <el-dialog
        title="明细列表"
        :visible.sync="detailListDialogVisible"
        width="641px"
        :before-close="handleClose">
        <el-table :data="detailListTableData" border stripe>
          <el-table-column prop="schoolName" label="学校" width="120"></el-table-column>
          <el-table-column prop="className" label="班级" width="120"></el-table-column>
          <el-table-column prop="realName" label="姓名" width="120"></el-table-column>
          <el-table-column prop="cardNo" label="卡号1" width="120"></el-table-column>
          <el-table-column prop="cardNo2" label="卡号2" width="120"></el-table-column>
        </el-table>
      </el-dialog>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      loading: false,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      total: 0,
      searchForm: {
        date: new Date().toISOString().slice(0, 10).replace(/-/g, '')
      },
      rules: {
        date: [{ required: true, message: '请选择日期', trigger: 'blur' }]
      },
      tableData: [],
      detailListDialogVisible: false,
      detailListTableData: []
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      this.getStatsForStudentReader()
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    handleClose (done) {
      done()
    },
    getStatsForStudentReader () {
      let _this = this
      this.$refs['searchForm'].validate((valid) => {
        if (valid) {
          _this.loading = true
          this.$axios.post(this.GLOBAL.host + '/attendence/getStatsForStudentReader',
            this.$qs.stringify({
              date: _this.searchForm.date
            })
          ).then(res => {
            if (res.data != null) {
              if (res.data.status === 200) {
                _this.tableData = res.data.data
              } else {
                this.$message.error(res.data.message)
              }
            }
            _this.loading = false
          })
        }
      })
    },
    getStatsDetailListForStudentReader (row, group) {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/attendence/getStatsDetailListForStudentReader',
        this.$qs.stringify({
          date: row.date,
          schoolId: row.schoolId,
          group: group
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.detailListDialogVisible = true
            _this.detailListTableData = res.data.data
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/StatsForStudentReader.vue